export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8715.5057c3f3.jpg";